import { Navigate, useParams } from "react-router";

/** Dialogs of the customers page that a legacy deep link can open (`?dialog=`). */
export type ContactsDialogName = "import" | "fields";

/** b29-04: old customers sub-pages and settings pages now land on the one customers page. */
export function ContactsRedirect({ dialog }: { readonly dialog?: ContactsDialogName }) {
  const { workspaceId } = useParams();
  return <Navigate replace to={`/w/${workspaceId}/contacts${dialog ? `?dialog=${dialog}` : ""}`} />;
}
